import { useContext } from 'react';

import { ThemeContext } from '@/shared/contexts';

export const useTheme = () => {
  const { changeTheme, theme } = useContext(ThemeContext);

  return {
    changeTheme,
    theme,
  };
};
